// 
import WebComponent from '../webComponents/WebComponent';

export default class AnchorsList extends WebComponent {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
    this.handlePageScroll = this.handlePageScroll.bind(this);
    this.getOffsetTop = this.getOffsetTop.bind(this);
    this.addBodyOffset = this.addBodyOffset.bind(this);
    this.removeBodyOffset = this.removeBodyOffset.bind(this);
    this.fixedState = false;
	}

	didMount() {
		const {
			childSelector,
			clickSelector,
			activeClass,
      fixedOnScroll,
		} = this.props;

		this.activeClass = activeClass;
		this.targetElements = this.element.querySelectorAll(childSelector);
    this.body = document.querySelector('body');

		if (this.targetElements.length > 0) {
			this.clickElements = this.element.querySelectorAll(clickSelector);
			this.activeElement = this.element.querySelector(childSelector + '.' + activeClass);

			if ((!this.activeElement) && (this.targetElements)) {
				this.activeElement = this.targetElements[0];
				this.activeElement.classList.add(activeClass);
			}

			Array.from(this.clickElements).forEach(link => {
				link.addEventListener('click', this.handleClick);
			});

			if (fixedOnScroll) {
        this.getOffsetTop();
        this.handlePageScroll();

        window.addEventListener('scroll', this.handlePageScroll);
        window.addEventListener('orientationchange', this.getOffsetTop);
      }
		}
	}

	willUnMount() {
    window.removeEventListener('scroll', this.handlePageScroll);
    window.removeEventListener('orientationchange', this.getOffsetTop);
    Array.from(this.clickElements).forEach(link => {
      link.removeEventListener('click', this.handleClick);
    });
  }

	handleClick(e) {
    const target = (document.querySelector(e.target.getAttribute('href')));
    let topOfElement = 0;
    const {
      fixedOnScroll,
    } = this.props;

    if (target) {
      e.preventDefault();

      if (fixedOnScroll) {
        topOfElement = target.offsetTop - (this.getHeight() + 15);
      }
      else {
        topOfElement = target.offsetTop;
      }
      window.scroll({ top: topOfElement, behavior: 'smooth' });
    }

		Array.from(this.targetElements).forEach(target => {
			target.classList.remove(this.activeClass);
		});
		e.target.parentNode.classList.add(this.activeClass);
	}
	handlePageScroll() {
	  const {
	    fixedClass,
    } = this.props;

	  let windowPosition = window.pageYOffset;

	  if (this.fixedState) {
	    windowPosition = window.pageYOffset + this.getHeight();
    }

    if (windowPosition >= this.offsetTop) {
      if (!this.fixedState) {
        this.element.classList.add(fixedClass);
        this.addBodyOffset();
        this.fixedState = true;
      }
    }
    else {
      if (this.fixedState) {
        this.removeBodyOffset();
        this.element.classList.remove(fixedClass);
        this.fixedState = false;
      }
    }
	}

	getHeight() {
    const styles = window.getComputedStyle(this.element);
    const margin = parseFloat(styles['marginTop']) +
      parseFloat(styles['marginBottom']);

    return Math.ceil(this.element.offsetHeight + margin);
  }

  addBodyOffset() {
    this.body.style.paddingTop = this.getHeight() + 'px';
  }

  removeBodyOffset() {
    this.body.style.paddingTop = 0;
  }
  getOffsetTop() {
    this.removeBodyOffset();
    this.offsetTop = this.element.getBoundingClientRect().top + window.pageYOffset;
  }
}

AnchorsList.defaultProps = {
	childSelector: 'li',
	clickSelector: 'li a',
	activeClass: 'active',
  fixedOnScroll: false,
  fixedClass: 'product-anchors--fixed',
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/AnchorsList.js